module.exports = __webpack_public_path__ + "img/Nav_check_grp.7cc1bf2d.svg";